// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDQMhVVcs5rclJDLHdsM5enq_Z-DUX9Kh0',
    authDomain: 'say-what-live.firebaseapp.com',
    projectId: 'say-what-live',
    storageBucket: 'say-what-live.appspot.com',
    messagingSenderId: '42394418630',
    appId: '1:42394418630:web:79267c9403bccdacc1c6c7',
    measurementId: 'G-VE0S079B6W'
  },
  base_url: 'localhost:4200',
  stripe: {
    stripe_publishable_key : 'pk_test_dnmjFLy3uj7fU5sOjfrrtvij',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
